import { correctArrowHorizontal, correctArrowVertical } from './correctArrow';
const maxOffsetTooltip = (shift, offset, size, parentSize = 0) => {
  const sign = shift >= 0 ? 1 : -1;
  const limitPlus = sign * (size - offset);
  const limitMinus = sign * (parentSize - offset);
  return shift >= 0 ? Math.min(limitPlus, shift) : Math.max(limitMinus, shift);
};
const maxOffsetArrow = (shift, offset, size, parentSize = 0) => {
  const sign = shift >= 0 ? 1 : -1;
  const limitPlus = sign * (size - parentSize / 2 - offset);
  const limitMinus = sign * (parentSize / 2 - offset);
  return shift >= 0 ? Math.min(limitPlus, shift) : Math.max(limitMinus, shift);
};
const setHorizontal = ({
  childrenRect,
  popoverRect,
  direction,
  additionalShift,
  customPadding,
  minArrowOffset,
  containerOffsets,
  arrowRect,
  arrowAdaptiveBorderRadiusValue
}) => {
  const styles = {
    tooltipStyle: {
      top: childrenRect.bottom - popoverRect.height + maxOffsetTooltip(additionalShift, minArrowOffset, popoverRect.height, childrenRect.height) + containerOffsets.top,
      left: direction === 'right' ? childrenRect.right + customPadding + containerOffsets.left : childrenRect.left - popoverRect.width - customPadding + containerOffsets.left
    },
    cornerStyle: {
      top: popoverRect.height - childrenRect.height / 2 - maxOffsetArrow(additionalShift, minArrowOffset, popoverRect.height, childrenRect.height)
    }
  };
  const {
    cornerStyle,
    tooltipStyle
  } = styles;
  return correctArrowVertical(cornerStyle, tooltipStyle, direction, popoverRect, arrowAdaptiveBorderRadiusValue, arrowRect);
};
const setVertical = ({
  childrenRect,
  popoverRect,
  direction,
  additionalShift,
  customPadding,
  windowMargin,
  minArrowOffset,
  containerOffsets,
  arrowRect,
  arrowAdaptiveBorderRadiusValue
}) => {
  const tooltipStyle = {
    top: direction === 'bottom' ? childrenRect.bottom + customPadding + containerOffsets.top : childrenRect.top - popoverRect.height - customPadding + containerOffsets.top,
    left: childrenRect.right - popoverRect.width + maxOffsetTooltip(additionalShift, minArrowOffset, popoverRect.width, childrenRect.width) + containerOffsets.left
  };
  const arrowLeft = popoverRect.width - childrenRect.width / 2;
  const cornerStyle = {
    left: arrowLeft - maxOffsetArrow(additionalShift, minArrowOffset, popoverRect.width, childrenRect.width)
  };

  // не даем вылезти тултипу за экран
  const left = childrenRect.right - popoverRect.width + maxOffsetTooltip(additionalShift, minArrowOffset, popoverRect.width, childrenRect.width);
  const realWindowMargin = Math.min(windowMargin, childrenRect.left);
  if (left < realWindowMargin) {
    tooltipStyle.left = realWindowMargin;
    cornerStyle.marginLeft = left - realWindowMargin;
  }
  return correctArrowHorizontal(cornerStyle, tooltipStyle, direction, popoverRect, arrowAdaptiveBorderRadiusValue, arrowRect);
};
export function setPositionEnd(args) {
  switch (args.direction) {
    case 'left':
    case 'right':
      return setHorizontal(args);
    case 'top':
    case 'bottom':
      return setVertical(args);
  }
}